import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';

import CS from '../../commons/services/Common'

export default function LineChart(props) {

    const [options, setOptions] = useState ({});
    const [dataChart, setDataChart] = useState (
        {
            datasets:[],
            labels:[]
        }
    );

    useEffect(() => {
        const fetchData = async () => {
            setDataChart(
                {
                    labels: props.labels,
                    datasets: props.datasets
                }
            );
            setOptions(
                {
                    tooltips: {
                        displayColors: false,
                        callbacks: {
                            title: function(tooltipItems, data) {
                                return '';
                            },
                            label: function(tooltipItem, data) {
                                var value = data.datasets[0].data[tooltipItem.index];
                                value = value.toString();
                                return `${CS.setComma(value)}kWh`;
                            }
                        }
                    },
                    title:{
                        display: false,
                        text: props.text,
                        fontSize: 20
                    },
                    legend:{
                        display: false,
                        position: 'right'
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display:false
                                },
                                ticks: {
                                    //fontColor: 'rgb(255,255,255)'
                                    userCallback: function(value, index, values) {
                                        return `${value.toString()}시`;
                                    }
                                }
                            }
                        ],
                        yAxes: [
                            {
                                display: true,
                                gridLines: {
                                    display:true
                                },
                                ticks: {
                                    beginAtZero: true,
                                    userCallback: function(value, index, values) {
                                        value = value.toString();
                                        return CS.setComma(value);
                                    }
                                }
                            }
                        ]
                    }
                }
            );
        };
        fetchData();
    }, [props.datasets]);

    return (
        <>
            <Line 
                data={dataChart}
                width={300}
                height={100}
                options={options}
            />
        </>
    );
}
